@switch (message().type) { @case (typeText) {
<div class="message message-text">
  @if (isLink) {
  <a [href]="message().text" target="_blank" class="link">{{ message().text }}</a>
  } @if (!isLink) {
  {{ message().text }}
  }
</div>
@if (!!timestamp) {
<div class="message-hint">{{ timestamp }}</div>
} } @case (typeFile) {
<div class="message-file">
  <label class="message-text message">{{ message().file.name }}</label>
  <button avButton ofType="icon" size="xs" (click)="downloadFile()">
    <av-icon
      name="download"
      [mode]="message().isLocal ? 'light' : 'dark'"
    ></av-icon>
  </button>
</div>
@if (!!timestamp) {
<div class="message-hint">{{ timestamp }}</div>
} } @case (typeBot) {
<div class="message-bot">
  <div class="message message-text">
    @if (isLink) {
    <a [href]="message().text" target="_blank" class="link">{{ message().text }}</a>
    } @if (!isLink) {
    {{ message().text }}
    }
  </div>
  @if (!!timestamp) {
  <div class="message-hint">{{ timestamp }}</div>
  } @if (!hasReplied && message().quickReplies?.length > 0) {
  <div class="message-bot-replies">
    @for (reply of message().quickReplies; track reply) {
    <button avButton (click)="quickReply(reply)" ofType="stroked" size="xs">
      {{ reply.text }}
    </button>
    }
  </div>
  }
</div>
} }
